module.exports = __webpack_public_path__ + "img/weed.5ae29cab.jpg";